import { useEffect, useState } from 'react';

/**
 * Shooting Stars（Aceternity UI 风格）— 夜空中的划落流星
 */
export function ShootingStars({
  count = 8,
  className = '',
}: {
  count?: number;
  className?: string;
}) {
  const [stars, setStars] = useState<Array<{ id: number; left: string; delay: string; duration: string }>>([]);

  useEffect(() => {
    const next = Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${(Math.random() * 6).toFixed(2)}s`,
      duration: `${(Math.random() * 3 + 4).toFixed(2)}s`,
    }));
    setStars(next);
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="absolute top-0 h-px w-px rounded-full bg-white"
          style={{
            left: s.left,
            animationDelay: s.delay,
            animationDuration: s.duration,
            animationIterationCount: 'infinite',
            animationName: 'shootingStar',
            animationTimingFunction: 'linear',
          }}
        >
          {/* 尾迹 */}
          <span
            className="absolute top-1/2 -z-10 h-px w-[100px] -translate-y-1/2 bg-gradient-to-r from-primary to-transparent"
            style={{ transform: 'rotate(215deg)' }}
          />
        </span>
      ))}
    </div>
  );
}
